import { graphql } from '@/utils/graphql';
import { logger } from '@/utils/logger';
import type { BedrockMessage } from '@/utils/beemAgentTypes';

const ns = 'app.woLint.generativeDashboard';

/**
 * Generates a short contextual dashboard title from a user prompt.
 * Uses the existing Insights Converse endpoint for a quick LLM call.
 */
export async function generateTitle(prompt: string): Promise<string> {
  try {
    const titlePrompt = `Generate a short, descriptive dashboard title (max 6 words) for this request. Reply with ONLY the title, nothing else. No quotes, no explanation.\n\nRequest: "${prompt}"`;
    const { messages } = await graphql('beemAgentInsightConverse', {
      query: {
        datasets: '[]',
        prompt: titlePrompt,
        messages: '[]',
      },
    });
    const parsed: BedrockMessage[] = JSON.parse(messages);
    const lastMsg = parsed[parsed.length - 1];
    if (lastMsg?.role === 'assistant' && lastMsg.content?.[0]?.text) {
      return lastMsg.content[0].text.trim().replace(/^["']|["']$/g, '');
    }
    return prompt.substring(0, 50);
  } catch (e) {
    logger.debug({ label: `${ns}.generateTitle.error`, message: e });
    return prompt.substring(0, 50);
  }
}
